import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { interceptor } from "utils/interceptor";
// import HomeContainer from "containers/Home/homeContainer";
// import Layout from "common/Layout";

import AuthContainer from "../Auth";
import TopHeader from "components/TopHeader";
import BottomFooter from "components/Footer";
import PrivacyPolicy from "components/Auth/PrivacyPolicy";
// import ForgotPassword from "components/PublicComponent/Auth/ForgotPassword/index";
// import RecoverPassword from "components/PublicComponent/Auth/RecoverPassword/index";
import { Layout } from "antd";
import Dashboard from "containers/Dashboard/Dashboard";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { generateUUID } from "utils/appUtil";
import useMQTTService from "hooks/useMQTTService";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Map from "containers/Map/Map";
import Video from "containers/Video/Video";
import { RootState } from "reducers/rootReducer";
import  useSocketNetworkLayer  from '../../services/socketNetworkLayer'

import useLocalStorageService from "../../services/localStorage"
import {UUID , TOKEN} from "../../constants/localStoreKeys";

const stripeKey: string = process.env.REACT_APP_STRIPE_KEY || "";

const stripePromise = loadStripe(stripeKey);

const { Header, Content, Footer } = Layout;

export default () => {
  const history = useHistory();
  const location = useLocation();
  const [isLoggedIn, setLoggedIn] = useState<boolean>();
  const { loginSuccessfull, registeredEmail, actionLogout } = useSelector(
    (state: RootState) => state.auth
  );
  const { client, mqttPublish, connectMQTT } = useMQTTService();

  const socket = useSocketNetworkLayer();
  const {getLocalStorageItem, setLocalStorageItem} = useLocalStorageService();


  useEffect(() => {
    console.log('location here', location);

    if (!getLocalStorageItem(UUID)) {
      localStorage.setItem(UUID, generateUUID())
    }
    return () => {
      if (client) {
        client.end(undefined, undefined, () => {
          console.log("Ended");
        });
      }
    };

  }, []);

  useEffect(() => {
    setLoggedIn(!!getLocalStorageItem(TOKEN));
  }, [isLoggedIn]);

  useEffect(() => {
    setLoggedIn(loginSuccessfull);
  }, [loginSuccessfull]);

  useEffect(() => {
    if(actionLogout){
      // setLoggedIn(false)
      // history.push("/auth/login");
      window.location.href = "/auth/login";
    }
  }, [actionLogout]);

  useEffect(() => {
     socket.connect();
  }, []);

  interceptor();

  return (
    <Elements stripe={stripePromise}>
      <Layout>
        {(!isLoggedIn || location.pathname.indexOf('auth') !== -1) && (
          <Header>
            <TopHeader />
          </Header>
        )}
        <Content className="site-layout">
          <Switch>
            <Route exact path="/">
              <Redirect to={`/auth/login`}/>
            </Route>
            <Route path="/auth" 
              // component={AuthContainer} 
              render={(props) => <AuthContainer {...props} socket={socket}  />}
            />
            <Route path="/privacy-policy" 
              // component={AuthContainer} 
              render={(props) => <PrivacyPolicy />}
            />
            <Route
              path="/dashboard"
              render={(props) => <Dashboard {...props} client={client}  socket={socket} />}
            />
            <Route
              path="/page/:pageId"
              render={(props) => <Dashboard {...props} client={client}  socket={socket} />}
            />
            <Route
              path="/page"
              render={(props) => <Dashboard {...props} client={client}  socket={socket} />}
            />
            <Route
              path="/map/:pageId"
              render={(props) => <Map {...props} socket={socket} />}
            />
            <Route
              path="/video/:pageId"
              render={(props) => <Video {...props} socket={socket}  />}
            />
          </Switch>
        </Content>
        {(!isLoggedIn || location.pathname.indexOf('auth') !== -1) && (
          <Footer>
            <BottomFooter />
          </Footer>
        )}
      </Layout>
    </Elements>
  );
};
